var _path, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 99,
    viewBox: "0 0 100 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9551 56.368V58.5438C36.9551 60.3426 41.3374 61.8051 46.7388 61.8051C52.1403 61.8051 56.5226 60.3426 56.5226 58.5438V56.368C54.4181 57.8508 50.5708 58.5438 46.7388 58.5438C42.9069 58.5438 39.0596 57.8508 36.9551 56.368ZM53.2613 42.2376C58.6628 42.2376 63.0451 40.7751 63.0451 38.9763C63.0451 37.1776 58.6628 35.7151 53.2613 35.7151C47.8599 35.7151 43.4776 37.1776 43.4776 38.9763C43.4776 40.7751 47.8599 42.2376 53.2613 42.2376ZM36.9551 51.0226V53.652C36.9551 55.4507 41.3374 56.9132 46.7388 56.9132C52.1403 56.9132 56.5226 55.4507 56.5226 53.652V51.0226C54.4181 52.7551 50.5657 53.652 46.7388 53.652C42.912 53.652 39.0596 52.7551 36.9551 51.0226ZM58.1532 51.5831C61.073 51.0175 63.0451 49.9678 63.0451 48.7601V46.5842C61.8629 47.4199 60.1252 47.9906 58.1532 48.3422V51.5831ZM46.7388 43.8682C41.3374 43.8682 36.9551 45.6925 36.9551 47.9448C36.9551 50.1971 41.3374 52.0213 46.7388 52.0213C52.1403 52.0213 56.5226 50.1971 56.5226 47.9448C56.5226 45.6925 52.1403 43.8682 46.7388 43.8682ZM57.9137 46.7371C60.9711 46.1868 63.0451 45.1065 63.0451 43.8682V41.6923C61.2361 42.9714 58.1277 43.6593 54.8563 43.8224C56.3595 44.551 57.4653 45.5294 57.9137 46.7371Z",
    fill: "#444444"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4732_1996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 0.0917489C77.2432 0.0917478 99.3281 22.1767 99.3281 49.4199C99.3281 76.663 77.2432 98.748 50 98.748C22.7568 98.748 0.671874 76.663 0.671873 49.4199C0.671872 22.1767 22.7568 0.0917501 50 0.0917489ZM50 80.4966C67.1632 80.4966 81.0767 66.5831 81.0767 49.4199C81.0767 32.2567 67.1632 18.3432 50 18.3432C32.8368 18.3432 18.9233 32.2567 18.9233 49.4199C18.9233 66.5831 32.8368 80.4966 50 80.4966Z",
    fill: "#D5EBFF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0288 71.6622C97.8217 64.1542 99.6316 55.8011 99.2866 47.3965C98.9416 38.992 96.4531 30.8153 92.0576 23.6434C87.6621 16.4716 81.5057 10.5429 74.1733 6.42077C66.8409 2.29864 58.5762 0.120023 50.1646 0.0919474L50.1037 18.3433C55.403 18.3609 60.6098 19.7335 65.2292 22.3304C69.8486 24.9273 73.7271 28.6624 76.4963 33.1807C79.2655 37.6989 80.8332 42.8503 81.0506 48.1451C81.2679 53.44 80.1277 58.7025 77.7382 63.4325L94.0288 71.6622Z",
    fill: "url(#paint0_linear_4732_1996)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4732_1996",
    x: 0.671875,
    y: 0.0917358,
    width: 98.6562,
    height: 100.656,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4732_1996"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4732_1996",
    x1: 99.3281,
    y1: 49.4198,
    x2: 0.671888,
    y2: 49.4198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DEBB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07892B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditHistory);
export default __webpack_public_path__ + "static/media/CreditHistory.1b40bc135d074f9c6de1868789541a8e.svg";
export { ForwardRef as ReactComponent };